import React, { Component } from 'react';
import InputText from './InputText';
import Select from 'react-select'

export class InviteUserForm extends Component {

    constructor(props) {
        super(props);
        this.state = {
            submissionError: false,
            submissionSuccess: false,
            onSubmitCallback: props.onSubmit,
            user: {
                email: "",
                role: ""
            }
        };

        this.handleInputStringChange = this.handleInputStringChange.bind(this);
        this.handleFormSubmit = this.handleFormSubmit.bind(this);
    }

    handleInputStringChange(e) {
        const value = e.target.value;
        const name = e.target.name;

        this.setState((state) => ({
            user: {
                ...state.user,
                [name]: value
            }
        }));
    }

    handleFormSubmit(e) {
        e.preventDefault();

        this.state.user.role = this.state.user.role.value;

        fetch('/api/user/invite-user', {
            method: "POST",
            body: JSON.stringify(this.state.user),
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
        }).then(response => {
            response.json().then(data => {
                if (response.ok) {
                    this.setState({ submissionSuccess: true });
                    if (this.state.onSubmitCallback) {
                        this.state.onSubmitCallback(data);
                    }
                } else {
                    console.error("Submission error", response);
                    this.setState({ submissionError: true });
                }
            })
        });
    }

    reset = () => {
        this.setState({
            submissionError: false,
            submissionSuccess: false,
            user: {
                email: "",
                role: ""
            }
        });
    };

    render() {
        if (this.state.submissionSuccess) {
            return (
                <div className="alert alert-success">
                    <p>User invite successfully sent!</p>
                    {!this.state.researcherId &&
                        <p><button type="button" className="btn btn-outline-info" onClick={this.reset}>Invite Another User</button></p>
                    }
                </div>
            );
        }

        if (this.state.submissionError) {
            return (
                <div className="alert alert-danger">
                    <p>Invite failed! Please try again.</p>
                    <p><a href="/manage-users" className="btn btn-info">Return to Manage Users</a></p>
                </div>
            );
        }

        return (
            <form onSubmit={this.handleFormSubmit}>
                <div className="row">
                    <div className="col">
                        <InputText required name="email" value={this.state.user.email} onChange={this.handleInputStringChange} label="Email" />
                    </div>
                    <div className="col">
                        <label>Role</label>
                        <Select isClearable rules={{ required: true }}  onChange={option => this.setState({ user: { ...this.state.user, role: option } })} options={[{ value: 'Member', label: 'Member' }, { value: 'Admin', label: 'Admin' }]} />
                    </div>
                </div>
                <br/>
                <div className="form-group">
                    <button type="submit" className="btn btn-success">Invite</button>
                </div>
            </form>
        );
    }
}